<script setup lang="ts">
import { toRef } from 'vue';

import VDialog from '@components/dialogs/VDialog/VDialog.vue';
import VForm from '@modules/forms/components/VForm/VForm.vue';
import { TRANSLATION_GROUP_FILE_UPLOAD } from '@modules/forms/constants';

import type { IReportUploadFileEmits, IReportUploadFileProps } from './types';
import { useReportUploadFile } from './composables';

const props = defineProps<IReportUploadFileProps>();
const emit = defineEmits<IReportUploadFileEmits>();

const {
  isLoading,
  errors,
  showDialog,
  uploadSchema,
  clearError,
  clearAllErrors,
  onSubmit,
  close,
} = useReportUploadFile(
  toRef(props, 'activeTab'),
  toRef(props, 'activeInnerTab'),
  toRef(props, 'queryOptions'),
  toRef(props, 'visible'),
  emit,
);
</script>

<template>
  <VDialog
    :visible="showDialog"
    :title="$getTranslation(TRANSLATION_GROUP_FILE_UPLOAD, 'TITLE')"
    @show="clearAllErrors"
    @hide="close"
  >
    <VForm
      :schema="uploadSchema"
      :custom-errors="errors"
      :is-loading="isLoading"
      @submit="onSubmit"
      @interacted="clearError"
    />
  </VDialog>
</template>
